/** Default country for structured address forms when creating a new row. */
export const DEFAULT_ADDRESS_COUNTRY = 'United States'
